/**
 * JS functions used across the whole system (admin and public)
 * This probably needs refactoring into modules
 */

var springSpace = springSpace || {};
springSpace.la = springSpace.la || {};
springSpace.Util = {};
{
    const selectText = function (element) {
        const selection = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);
    };
    /**
     * Repopulate a form from a serialized query string
     * @param {String} string query string from url
     * @param {String} formId
     */
    const rePopForm = function (string, formId) {
        string = string.replace(/^\?/, '');
        string = decodeURIComponent(string);
        var parts = string.split('&');
        const form = document.getElementById(formId);
        // A springy-select is only reset the first time a value for it turns
        // up below, so a select with nothing in the query string keeps
        // whatever the server just rendered (e.g. a session-based default)
        // instead of always being cleared to empty.
        const resetSpringySelects = new Set();
        for (var i = 0; i < parts.length; i++) {
            var pair = decodeURIComponent(parts[i]).split('=');
            var _name = pair[0];
            var value = pair[1];
            if (typeof value == 'undefined') {
                continue;
            }
            value = value.replace(/\+/g, ' ');

            // account for multiple/array
            // sometimes it comes in as key[0], key[1] rather than just key[]
            if (_name.match(/\[.*?\]/)) {
                var newname = _name.replace(/\[.*?\]/, '[]');
                const select = form.querySelector(`select[name="${newname}"]`);
                if (!select) {
                    continue;
                }
                const springySelect = select.closest('springy-select');
                if (!springySelect) {
                    const option = select.querySelector(`option[value="${value}"]`);
                    if (option) {
                        option.selected = true;
                    }
                } else {
                    if (!resetSpringySelects.has(springySelect)) {
                        springySelect.set([]);
                        resetSpringySelects.add(springySelect);
                    }
                    const vals = springySelect.get();
                    vals.push(value);
                    springySelect.set(vals);
                }
            } else {
                const input = form.querySelector(`*[name="${_name}"]`);
                if (!input) {
                    continue;
                }
                const springySelect = input.closest('springy-select');
                if (!springySelect) {
                    input.value = value;
                } else {
                    springySelect.set([value]);
                }
            }
        }
    };

    springSpace.Util = {
        selectText,
        rePopForm,
    };
}

/**
 * Close a Bootstrap modal
 * BS5: this is overriden in ModalBS5.js so the bs5 version will work
 * @param {String} [modal_id] id of modal div, else will default to a displayed element with class modal
 */
// eslint-disable-next-line no-unused-vars
function closeModal(modal_id) {
    var $modal = null;
    if (typeof modal_id == 'undefined') {
        jQuery('.modal').each(function (i, el) {
            if (jQuery(el).css('display') !== 'none') {
                $modal = jQuery(el);
            }
        });
    } else {
        $modal = jQuery('#' + modal_id);
    }

    if ($modal !== null) {
        // $modal.modal('hide');
        $modal.modal('hide').removeData('bs.modal').find('.modal-content').html('');
    }
}
/**
 * Disables a button
 * @param {String} btnsel selector for button
 */
// eslint-disable-next-line no-unused-vars
function disableButton(btnsel) {
    if (!btnsel) {
        return;
    }
    if (['#', '.'].indexOf(btnsel.charAt(0)) === -1) {
        btnsel = '#' + btnsel;
    }
    jQuery(btnsel).prop('disabled', true);
}
/**
 * reenables a button
 * @param {String} btnsel selector for button
 */
// eslint-disable-next-line no-unused-vars
function enableButton(btnsel) {
    if (!btnsel) {
        return;
    }
    if (['#', '.'].indexOf(btnsel.charAt(0)) === -1) {
        btnsel = '#' + btnsel;
    }
    jQuery(btnsel).prop('disabled', false);
}

/**
 * Notification functions used through the system
 */

var errorAlert = function (msg = '') {
    window.suiNotify.hideWorking();
    window.suiNotify.error(msg);
};
// eslint-disable-next-line no-unused-vars
var successAlert = function (msg = '', ms = 0) {
    window.suiNotify.hideWorking();
    if (msg === '') {
        ms = 5000;
    }
    window.suiNotify.success(msg, null, ms);
};
// eslint-disable-next-line no-unused-vars
var workingAlert = function (msg = '') {
    window.suiNotify.working(msg);
};
/**
 * Hide working alerts only
 */
// eslint-disable-next-line no-unused-vars
var stopAlert = function () {
    window.suiNotify.hideWorking();
};

/**
 * Generic get error message from Response class error.
 * @deprecated prefer version in tools/requestUtil.js when possible
 * @param {Object} jqXhr JQuery xhr object.
 * @returns {String}
 */

var jqGetAjaxError = function (jqXhr) {
    let error = '';
    if (jqXhr.responseText) {
        try {
            const response = JSON.parse(jqXhr.responseText);
            if (response.error) {
                error = response.error;
            }
        } catch {
            error = 'Invalid response received';
        }
    }
    return error;
};
/**
 * Generic fail callback for jQuery ajax requests.
 * This handles the object error genered in the php Response class.
 * @param {Object} jqXhr JQuery xhr object.
 */
// eslint-disable-next-line no-unused-vars
var jqAjaxFailCallback = function (jqXhr) {
    const error = jqGetAjaxError(jqXhr);
    errorAlert(error);
};

/**
 * Create a dismissable error alert for insertion into the DOM.
 * Uses bootstrap.
 * @param {String} message HTML Error message (html)
 * @param {String} id Optional html id for alert.
 * @returns {HTMLElement}
 */
var createDismissableErrorAlert = function (message = '', id = '') {
    if (!message) {
        message = 'Error';
    }
    return createDismissableAlert(message, 'danger', id);
};

/**
 * Create a dismissable success alert for insertion into the DOM.
 * Uses bootstrap.
 * @param {String} message HTML Error message (html)
 * @param {String} id Optional html id for alert.
 * @returns {HTMLElement}
 */
// eslint-disable-next-line no-unused-vars
var createDismissableSuccessAlert = function (message = '', id = '') {
    if (!message) {
        message = 'Success';
    }
    return createDismissableAlert(message, 'success', id);
};

/**
 * Create a dismissable error alert for insertion into the DOM.
 * Message generated from jquery ajax error.
 * Uses bootstrap.
 * @param {Object} jqXhr JQuery xhr object.
 * @returns {HTMLElement}
 */
// eslint-disable-next-line no-unused-vars
var createDismissableJQAjaxFailAlert = function (jqXhr) {
    const error = jqGetAjaxError(jqXhr);
    return createDismissableErrorAlert(error);
};

/**
 * Create a dismissable alert for insertion into the DOM.
 * Uses bootstrap.
 * @param {String} message HTML Error message (html)
 * @param {String} colorClass Bootstrap based (danger, success, info, etc.)
 * @param {String} id Optional html id for alert.
 * @returns {HTMLElement}
 */
var createDismissableAlert = function (message, colorClass, id = '') {
    var alert = document.createElement('div');
    if (id !== '') {
        alert.id = id;
    }
    alert.classList.add('alert', 'alert-' + colorClass, 'alert-dismissible', 'mt-3');
    alert.setAttribute('role', 'alert');
    alert.setAttribute('aria-atomic', 'true');
    var button = document.createElement('button');
    button.type = 'button';
    button.classList.add('btn-close', 'me-3');
    button.setAttribute('aria-label', window?.springyText?.modal?.close || 'close');
    button.setAttribute('data-bs-dismiss', 'alert');
    alert.appendChild(button);
    alert.insertAdjacentHTML('afterbegin', message);
    return alert;
};

// eslint-disable-next-line no-unused-vars
var createWorkingAlert = function (id = '') {
    const alert = document.createElement('div');
    if (id !== '') {
        alert.id = id;
    }
    alert.classList.add('alert', 'alert-working');
    alert.setAttribute('role', 'alert');
    alert.setAttribute('aria-atomic', 'true');

    alert.innerHTML = '<i class="fa fa-spinner fa-pulse mg-right" aria-hidden="true"></i> <span>Working...</span>';
    return alert;
};
